import React from 'react';

interface SheetRowProps {
  icon: React.ReactNode;
  label: string;
  right?: React.ReactNode;
  onClick?: () => void;
  destructive?: boolean;
}

// One row pattern shared by sheet bodies (currently profile sheet rows: dark mode
// toggle, Settings link, Sign out). Same icon size, same label typography,
// right-side slot for an optional trailing control. `destructive` paints the
// icon + label red for actions like Sign out.
export function SheetRow({ icon, label, right, onClick, destructive }: SheetRowProps) {
  const color = destructive ? 'var(--red)' : 'var(--text)';
  const iconColor = destructive ? 'var(--red)' : 'var(--text2)';
  const Tag: any = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className="m-row"
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 10, width: '100%', minHeight: 44,
        padding: '12px 10px', borderRadius: 10,
        background: 'none', border: 'none',
        fontFamily: 'inherit', fontSize: 'var(--m-text-meta)', color,
        textAlign: 'left' as const,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
        <span style={{ width: 18, height: 18, color: iconColor, flexShrink: 0, display: 'flex' }}>{icon}</span>
        <span style={{ fontSize: 'var(--m-text-meta)', fontWeight: destructive ? 500 : 400 }}>{label}</span>
      </span>
      {right && <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{right}</span>}
    </Tag>
  );
}
